import React from "react";
/* Import Boostrap */
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import ContainerWidget from '../containers/container-widget';
import Heading3 from '../titles/Heading3';

import { LinkedinButton, TwitterFollowButton } from 'react-social-sharebuttons';


const FooterDescription = ({ translate, props }) => {
    return (
         <Row>
				<Col md={4}>
					<ContainerWidget>
						<Heading3 title={props.footerContent[0].title}/>
						<img className="chamber-of-commerce chamber" src={"../images/"+props.footerContent[0].imageChamber} alt="Chamber Of Commerce" />
					</ContainerWidget>
					<ContainerWidget>
						<img className="microsoft-partner chamber" src={"../images/"+props.footerContent[0].imagePartner} alt="Microsoft Partner" />
					</ContainerWidget>
					<ContainerWidget>
						<a href="https://teams.sourceseek.com/romania/bucharest/members/bt-t-software-development?from=badge" title="Find me on SourceSeek" target="_blank"><img src="https://teams.sourceseek.com/images/memberbadge.png" border="0" /></a>
					</ContainerWidget>
				</Col>

				<Col md={4}>
					<ContainerWidget>
						<Heading3 title={props.footerContent[1].title}/>
						<ul className="gtco-footer-links">
							<li>
							 	<TwitterFollowButton user={"bttsd"}  />
							</li>
							<li>
								<LinkedinButton lang="en"/>
								
							</li>
						</ul>
					</ContainerWidget>
				</Col>

				<Col md={4}>
					<ContainerWidget>
						<Heading3 title={props.footerContent[2].title}/>
						<ul className="gtco-quick-contact">
							<li><a href="tel:+40(31)8059075"><i className="icon-phone"></i> +40 (31) 805 90 75</a></li>
							<li><a href="tel:+40(746)978968"><i className="icon-phone"></i> +40 (746) 978 968</a></li>
							<li><a href="mailto:info@bttsd.com"><i className="icon-mail2"></i> info@bttsd.com</a></li>
							<li> VAT/CUI RO18102445</li>
							<li>Str. Dobrota 12, <br />2nd floor,<br /> Sector 2, 020177<br />Bucharest, Romania</li>
						</ul>
					</ContainerWidget>
				</Col>

			</Row>
    );
}

const mapStateToProps = (state, ownProps) => {
  return {
    translate: getTranslate(state.locale),
    props: ownProps
  };
};

export default connect(mapStateToProps)(FooterDescription);	


// WEBPACK FOOTER //
// ./src/components/footer/footer-description.js